module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/asF0z2/tc-custom/9781683353850.jpg?1704537868126",
      "alt": "This image is the cover for the book Beneath the Citadel"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Beneath the Citadel\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The author of Iron Cast delivers “a thrilling adventure story” in this YA fantasy novel of dangerous rebellion against rules with the power of prophecy ("), _c('i', [_vm._v("Kirkus")]), _vm._v(").")]), _c('br'), _c('br'), _vm._v("In the city of Eldra, people are ruled by ancient prophecies. For centuries, the high council has stayed in power by virtue of the prophecies of the elder seers. After the last infallible prophecy came to pass, growing unrest led to murders and an eventual rebellion that raged for more than a decade. "), _c('br'), _c('br'), _vm._v("Now Cassa, the orphaned daughter of rebels, is determined to fight back against the high council, which governs Eldra from behind the walls of the citadel. Her only allies are no-nonsense Alys, easygoing Evander, and perpetually underestimated Newt. As Cassa struggles to live up to her parents’ legacy, she and her friends try to uncover the mystery of the final infallible prophecy—before it’s too late to save the city.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Destiny Soria\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Destiny Soria lives and works in the shadow of the mighty Vulcan statue in Birmingham, Alabama. Destiny’s first book, Iron Cast, was published in 2016 to critical acclaim.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Amulet Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0